"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _core = require("@emotion/core");

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var Instagram = function Instagram(props) {
  return (0, _core.jsx)("svg", (0, _extends2.default)({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30"
  }, props), (0, _core.jsx)("path", {
    d: "M27.576 21.696a5.88 5.88 0 01-5.88 5.88H8.304a5.88 5.88 0 01-5.88-5.88V8.304a5.88 5.88 0 015.88-5.88h13.392a5.88 5.88 0 015.88 5.88v13.392zM21.73 0H8.27A8.27 8.27 0 000 8.27v13.46A8.27 8.27 0 008.27 30h13.46A8.27 8.27 0 0030 21.73V8.27A8.27 8.27 0 0021.73 0z",
    fill: "currentColor"
  }), (0, _core.jsx)("path", {
    d: "M15 20.218a5.218 5.218 0 110-10.436 5.218 5.218 0 010 10.436M15 7a8 8 0 100 16 8 8 0 000-16M25 6.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0",
    fill: "currentColor"
  }));
};

var _default = Instagram;
var _default2 = _default;
exports.default = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(Instagram, "Instagram", "/builds/bA1zbJom/0/gojob/ui-bits/src/Footer/assets/Instagram.tsx");
  reactHotLoader.register(_default, "default", "/builds/bA1zbJom/0/gojob/ui-bits/src/Footer/assets/Instagram.tsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9Gb290ZXIvYXNzZXRzL0luc3RhZ3JhbS50c3giXSwibmFtZXMiOlsiSW5zdGFncmFtIiwicHJvcHMiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7O0FBQUE7Ozs7Ozs7Ozs7Ozs7QUFFQSxJQUFNQSxTQUEyRCxHQUFHLFNBQTlEQSxTQUE4RCxDQUFDQyxLQUFELEVBQVc7QUFDN0UsU0FDRTtBQUFLLElBQUEsS0FBSyxFQUFFLEVBQVo7QUFBZ0IsSUFBQSxNQUFNLEVBQUUsRUFBeEI7QUFBNEIsSUFBQSxPQUFPLEVBQUM7QUFBcEMsS0FBb0RBLEtBQXBELEdBQ0U7QUFDRSxJQUFBLENBQUMsRUFBQyxvUUFESjtBQUVFLElBQUEsSUFBSSxFQUFDO0FBRlAsSUFERixFQUtFO0FBQ0UsSUFBQSxDQUFDLEVBQUMscUlBREo7QUFFRSxJQUFBLElBQUksRUFBQztBQUZQLElBTEYsQ0FERjtBQVlELENBYkQ7O2VBZWVELFM7Ozs7Ozs7Ozs7OzswQkFmVEEsUyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCwgeyBGdW5jdGlvbkNvbXBvbmVudCB9IGZyb20gJ3JlYWN0JztcblxuY29uc3QgSW5zdGFncmFtOiBGdW5jdGlvbkNvbXBvbmVudDxSZWFjdC5TVkdQcm9wczxTVkdTVkdFbGVtZW50Pj4gPSAocHJvcHMpID0+IHtcbiAgcmV0dXJuIChcbiAgICA8c3ZnIHdpZHRoPXszMH0gaGVpZ2h0PXszMH0gdmlld0JveD1cIjAgMCAzMCAzMFwiIHsuLi5wcm9wc30+XG4gICAgICA8cGF0aFxuICAgICAgICBkPVwiTTI3LjU3NiAyMS42OTZhNS44OCA1Ljg4IDAgMDEtNS44OCA1Ljg4SDguMzA0YTUuODggNS44OCAwIDAxLTUuODgtNS44OFY4LjMwNGE1Ljg4IDUuODggMCAwMTUuODgtNS44OGgxMy4zOTJhNS44OCA1Ljg4IDAgMDE1Ljg4IDUuODh2MTMuMzkyek0yMS43MyAwSDguMjdBOC4yNyA4LjI3IDAgMDAwIDguMjd2MTMuNDZBOC4yNyA4LjI3IDAgMDA4LjI3IDMwaDEzLjQ2QTguMjcgOC4yNyAwIDAwMzAgMjEuNzNWOC4yN0E4LjI3IDguMjcgMCAwMDIxLjczIDB6XCJcbiAgICAgICAgZmlsbD1cImN1cnJlbnRDb2xvclwiXG4gICAgICAvPlxuICAgICAgPHBhdGhcbiAgICAgICAgZD1cIk0xNSAyMC4yMThhNS4yMTggNS4yMTggMCAxMTAtMTAuNDM2IDUuMjE4IDUuMjE4IDAgMDEwIDEwLjQzNk0xNSA3YTggOCAwIDEwMCAxNiA4IDggMCAwMDAtMTZNMjUgNi41YTEuNSAxLjUgMCAxMS0zIDAgMS41IDEuNSAwIDAxMyAwXCJcbiAgICAgICAgZmlsbD1cImN1cnJlbnRDb2xvclwiXG4gICAgICAvPlxuICAgIDwvc3ZnPlxuICApO1xufTtcblxuZXhwb3J0IGRlZmF1bHQgSW5zdGFncmFtO1xuIl19